import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import "../../../utils/quiz-parser.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizProblem, PrintQuizImage, getStyles } from "./print-common.js";
function ColoringPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const digits = quiz.digits || 0;
  const rows = quiz.rows || 1;
  const inverted = quiz.inverted ?? false;
  const itemsPerRow = Math.ceil(digits / rows);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const offImageUrl = getImageUrl(quiz.coloringOffImage);
  const rowIndices = [];
  for (let r = 0; r < rows; r++) {
    const start = r * itemsPerRow;
    const end = Math.min(start + itemsPerRow, digits);
    const indices = [];
    for (let i = start; i < end; i++) indices.push(i);
    rowIndices.push(indices);
  }
  const correctAnswerArray = (() => {
    if (!showCorrectAnswers || !(correctAnswers == null ? void 0 : correctAnswers[0])) return null;
    const correctStr = correctAnswers[0];
    if (correctStr.length === digits && /^[01]+$/.test(correctStr)) {
      return correctStr.split("").map(Number);
    }
    const count = parseInt(correctStr, 10);
    if (!isNaN(count)) {
      const arr = Array(digits).fill(inverted ? 1 : 0);
      for (let i = 0; i < Math.min(count, digits); i++) arr[i] = inverted ? 0 : 1;
      return arr;
    }
    return null;
  })();
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    /* @__PURE__ */ jsx(
      PrintQuizProblem,
      {
        problem: quiz.problem,
        quizId,
        additionalImages: quiz.additionalImages,
        compact,
        stripBlanks: true
      }
    ),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col items-center gap-[4px] w-full", children: rowIndices.map((rowItems, rowIndex) => /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center gap-[4px]", children: rowItems.map((itemIndex) => {
      const isShaded = correctAnswerArray ? correctAnswerArray[itemIndex] === 1 : false;
      return offImageUrl ? /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "w-[56px] h-[56px] flex items-center justify-center rounded-[4px] border border-transparent",
            isShaded && "border-[#e50000] bg-[#e50000]/10"
          ),
          children: /* @__PURE__ */ jsx("img", { src: offImageUrl, alt: `item-${itemIndex}`, className: "w-[48px] h-[48px] object-contain" })
        },
        itemIndex
      ) : /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "w-[40px] h-[40px] border border-gray-400",
            isShaded ? "border-[#e50000] bg-[#e50000]" : "bg-white"
          )
        },
        itemIndex
      );
    }) }, rowIndex)) })
  ] });
}
export {
  ColoringPrint
};
//# sourceMappingURL=coloring-print.js.map
